<template>
  <modal
    :active="active"
    size="small"
    :close-on-click-outside="true"
    primary-button-label="Accept"
    tertiary-button-label="Cancel"
    @onClose="$emit('onModalClose')"
    @onConfirm="submitAccept()">
    <template #header>
      <p>Accept Summary</p>
    </template>
    <template #content>
      <div class="dispute-comment-accept-summary-body">
        Do you want to accept this summary?
      </div>
    </template>
  </modal>
</template>
  
  <script>
export default {
  name: "AcceptCommentsModal",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    submitAccept() {
      this.$emit("onAccept");
      this.$emit("onModalClose");
    },
  },
};
</script>

  